import { A as AccountDrawer, S as SearchSpringElement, C as CountrySelectorDrawer, p as processGWP, R as RedesignMegaMenu, a as CustomFooter, i as initOsanoDialogGuards } from "./gwp-CbweQ2_Z.js";
import { l as lazyLoadImages, o as onResizeDebounced, U as UniversalModal, C as CartComponent } from "./product-config-BBuQ2RXH.js";
import "./render-product-cards-C86dq60y.js";
import "./manageSearchSpringCookies-BlSmBYu9.js";
if (!window._JK) window._JK = {};
class CustomHeader extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    const sourceSection = document.querySelector("#shopify-section-redesign-header");
    const addTobagModal = document.querySelector("#add-to-bag-modal--wrapper");
    if (!sourceSection) {
      console.warn("#shopify-section-redesign-header not found. Aborting component init.");
      return;
    }
    const linkTailwind = document.createElement("link");
    linkTailwind.rel = "stylesheet";
    linkTailwind.href = _JK.config.assetTailwindStyle;
    const linkStyle = document.createElement("link");
    linkStyle.rel = "stylesheet";
    linkStyle.href = _JK.config.assetThemeStyle;
    const template = document.createElement("template");
    template.innerHTML = `
      <style>
        :host {
          --tw-translate-x: 0;
          --tw-translate-y: 0;
          --tw-translate-z: 0;
          --tw-scale-x: 1;
          --tw-scale-y: 1;
          --tw-scale-z: 1;
          --tw-rotate-x: initial;
          --tw-rotate-y: initial;
          --tw-rotate-z: initial;
          --tw-skew-x: initial;
          --tw-skew-y: initial;
          --tw-space-y-reverse: 0;
          --tw-border-style: solid;
          --tw-leading: initial;
          --tw-font-weight: initial;
          --tw-tracking: initial;
          --tw-shadow: 0 0 #0000;
          --tw-shadow-color: initial;
          --tw-shadow-alpha: 100%;
          --tw-inset-shadow: 0 0 #0000;
          --tw-inset-shadow-color: initial;
          --tw-inset-shadow-alpha: 100%;
          --tw-ring-color: initial;
          --tw-ring-shadow: 0 0 #0000;
          --tw-inset-ring-color: initial;
          --tw-inset-ring-shadow: 0 0 #0000;
          --tw-ring-inset: initial;
          --tw-ring-offset-width: 0px;
          --tw-ring-offset-color: #fff;
          --tw-ring-offset-shadow: 0 0 #0000;
          --tw-outline-style: solid;
          --tw-blur: initial;
          --tw-brightness: initial;
          --tw-contrast: initial;
          --tw-grayscale: initial;
          --tw-hue-rotate: initial;
          --tw-invert: initial;
          --tw-opacity: initial;
          --tw-saturate: initial;
          --tw-sepia: initial;
          --tw-drop-shadow: initial;
          --tw-drop-shadow-color: initial;
          --tw-drop-shadow-alpha: 100%;
          --tw-drop-shadow-size: initial;
          --tw-duration: initial;
          --tw-ease: initial;
          --tw-content: "";
        }
        .sticky .main-logo {
            width: 100%;
            left: 0;
        }
      </style>
      ${sourceSection.innerHTML}
      ${addTobagModal.innerHTML}
    `;
    this.shadowRoot.appendChild(linkTailwind);
    this.shadowRoot.appendChild(linkStyle);
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    sourceSection == null ? void 0 : sourceSection.remove();
    addTobagModal == null ? void 0 : addTobagModal.remove();
    const displayDelay = 1e3;
    setTimeout(() => {
      this.style.display = "block";
    }, displayDelay);
    requestAnimationFrame(() => {
      this.accountDrawer = new AccountDrawer(this.shadowRoot);
      this.searchSpring = new SearchSpringElement(this.shadowRoot);
      this.countrySelector = new CountrySelectorDrawer(this.shadowRoot);
      this.accountLink = this.shadowRoot.querySelector(".account-link");
      this.mobileBTN = this.shadowRoot.getElementById("mobile__menu-btn");
      this.menudrawer = this.shadowRoot.getElementById("mobile__menu-drawer");
      this.closeDrawer = this.shadowRoot.getElementById("mobile__menu--close-drawer");
      this.backBtn = this.shadowRoot.getElementById("mobile__menu--back-drawer");
      this.desktopMenu = this.shadowRoot.querySelector(".nav-desktop");
      this.mobileMenu = this.shadowRoot.querySelector(".nav-mobile");
      this.searchModal = this.shadowRoot.querySelector(".modal-search");
      this.customCartDrawer = document.querySelector("jk-cart-drawer");
      if (!_JK.__gwpInit) {
        processGWP(this.customCartDrawer.shadowRoot);
        _JK.__gwpInit = true;
      }
      this.openDrawerBtn = this.shadowRoot.getElementById("openDrawerBtn");
      if (!this.accountLink || !this.mobileBTN || !this.desktopMenu) {
        console.warn("⚠️ One or more header elements were not found in the shadow DOM.");
      }
      this.init();
    });
  }
  init() {
    this.initMegaMenu(".mega-menu");
    this.replicateDesktopMenuToMobile();
    this.prepareMobileDrawerRendering();
    this.subItems = this.mobileMenu.querySelectorAll(".sub-item.has--dropdown");
    this.mobileMegaMenus = this.mobileMenu.querySelectorAll(".mega-menu");
    this.handleMobileDrawerMenu("mobile__menu--close-drawer", "mobile__menu--back-drawer");
    const tabs = this.mobileMenu.querySelectorAll(".menu-item");
    const tabContents = this.mobileMenu.querySelectorAll(".menu-item--content");
    this.handleMobileTabMenu(tabs, tabContents);
    this.openMobileMenu();
    this.closeMobileMenu();
    this.accountDrawer.init();
    this.countrySelector.init();
    this.attachCountrySelectorTrigger();
    this.openCartDrawer();
    this.enableDesktopMegamenu();
    this.initSearchModal(".modal-search", ".header-utility--search, .header-utility--search-mobile", "#close-search-modal");
    lazyLoadImages(this.shadowRoot);
    onResizeDebounced(() => {
      this.accountDrawer.init();
      this.toggleMobileDrawer(window.innerWidth <= _JK.helpers.JSbreakpoints.mobile);
    });
  }
  prepareMobileDrawerRendering() {
    if (!this.menudrawer) return;
    this.menudrawer.classList.add("mobile__menu-drawer--prepped");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        var _a, _b;
        (_a = this.menudrawer) == null ? void 0 : _a.classList.add("mobile__menu-drawer--ready");
        (_b = this.menudrawer) == null ? void 0 : _b.classList.remove("mobile__menu-drawer--prepped");
      });
    });
  }
  toggleMobileDrawer(isMobile) {
    const drawer = this.shadowRoot.getElementById("submenu-mobile__drawer");
    if (drawer) {
      drawer.style.display = isMobile ? "block" : "none";
    }
  }
  openCartDrawer() {
    var _a;
    (_a = this.openDrawerBtn) == null ? void 0 : _a.addEventListener("click", () => this.customCartDrawer.openDrawer());
  }
  enableDesktopMegamenu() {
    var _a;
    if (!this.desktopMenu || typeof ((_a = SDG == null ? void 0 : SDG.Data) == null ? void 0 : _a.context) !== "string") return;
    const context = SDG.Data.context.toLowerCase();
    const currentPath = window.location.pathname;
    let matchedMenu = null;
    let matchedTab = null;
    const allMenuContents = this.desktopMenu.querySelectorAll(".menu-item--content");
    const allTabLinks = this.desktopMenu.querySelectorAll("a.tab-link");
    allTabLinks.forEach((link) => {
      const href = link.getAttribute("href");
      link.classList.remove("active-tab", "before:w-full");
      if (href === currentPath && href !== "/") {
        matchedTab = link;
      }
    });
    if (matchedTab) {
      matchedTab.classList.add("active-tab", "before:w-full");
    }
    allMenuContents.forEach((menu) => {
      var _a2;
      const menuContext = ((_a2 = menu.getAttribute("data-menu-context")) == null ? void 0 : _a2.toLowerCase()) || "";
      if (!matchedTab) {
        const tabItem = menu.previousElementSibling;
        tabItem == null ? void 0 : tabItem.classList.remove("active-tab", "before:w-full");
      }
      if (menuContext && menuContext === context) {
        matchedMenu = menu;
      }
    });
    const menuToShow = matchedMenu || allMenuContents[0];
    const tabToActivate = menuToShow == null ? void 0 : menuToShow.previousElementSibling;
    if (menuToShow) {
      menuToShow.classList.remove("invisible");
      menuToShow.classList.add("visible");
    }
    if (tabToActivate && tabToActivate !== matchedTab && !matchedTab) {
      tabToActivate.classList.add("active-tab", "before:w-full");
    }
  }
  initSearchModal(modalSelector, triggerSelector, closeSelector) {
    var _a, _b;
    this.searchModal = new UniversalModal(modalSelector, triggerSelector, closeSelector, this.shadowRoot);
    this.searchSpring.init();
    const displayHeaderStyle = getComputedStyle(this.shadowRoot.querySelector(".header_action-items")).display;
    if (displayHeaderStyle === "flex") {
      const pencilBannerHeight = ((_a = document.querySelector(".redesign-pencil-banner")) == null ? void 0 : _a.clientHeight) || 0;
      const headerHeight = ((_b = this.shadowRoot.querySelector("header")) == null ? void 0 : _b.clientHeight) || 0;
      this.shadowRoot.querySelector(".modal-search").style.top = `${pencilBannerHeight + headerHeight}px`;
    }
  }
  initMegaMenu(menuSelector) {
    this.shadowRoot.querySelectorAll(menuSelector).forEach((menuElement) => {
      new RedesignMegaMenu(menuElement);
    });
  }
  replicateDesktopMenuToMobile() {
    this.mobileMenu.innerHTML = this.desktopMenu.innerHTML;
    const subItems = this.mobileMenu.querySelectorAll(".sub-item-primary.has--dropdown");
    subItems.forEach((el) => {
      el.className = "has--dropdown sub-item px-20 py-5.5 text-charcoal-100 redesign-body-2 inline-block";
    });
    const subItems2 = this.mobileMenu.querySelectorAll(".sub-item-primary.has--no--dropdown");
    subItems2.forEach((el) => {
      el.className = "sub-item px-20 py-7 text-charcoal-100 redesign-body-3 inline-block";
    });
    if (window.innerWidth <= _JK.helpers.JSbreakpoints.mobile) {
      const drawerDiv = document.createElement("div");
      drawerDiv.classList.add("submenu-drawer", "translate-x-full", "duration-500", "w-full");
      drawerDiv.setAttribute("id", "submenu-mobile__drawer");
      drawerDiv.style.position = "fixed";
      drawerDiv.style.top = "0";
      drawerDiv.style.left = "0";
      drawerDiv.style.height = "100vh";
      drawerDiv.style.overflow = "hidden";
      drawerDiv.style.backgroundColor = "var(--color-ivory)";
      drawerDiv.style.zIndex = 99;
      drawerDiv.style.textAlign = "center";
      if (this.shadowRoot) {
        this.shadowRoot.appendChild(drawerDiv);
      }
    }
  }
  createMenu(label, url, id) {
    const linkWrapper = document.createElement("div");
    linkWrapper.classList.add("flex", "items-center", "sub-item");
    const link = document.createElement("a");
    link.href = url;
    link.title = label;
    link.id = id;
    link.classList.add(
      "redesign-body-3",
      "cursor-pointer",
      "sub-item",
      "has--dropdown",
      "inline-flex",
      "items-center",
      "gap-2",
      "text-ivory",
      "bg-none",
      "pl-0",
      "pr-0",
      "pt-0",
      "pb-7",
      "outline-none",
      "capitalize",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "before:absolute",
      "before:left-0",
      "before:bottom-15",
      "before:h-1",
      "before:w-0",
      "before:bg-charcoal-100",
      "before:transition-all",
      "before:duration-300",
      "hover:before:w-full",
      "h-48",
      "capitalize"
    );
    link.textContent = label;
    linkWrapper.appendChild(link);
    return linkWrapper;
  }
  handleMobileDrawerMenu(closeDrawerSelector, backBtnSelector) {
    const closeDrawer = this.shadowRoot.getElementById(closeDrawerSelector);
    const backBtn = this.shadowRoot.getElementById(backBtnSelector);
    const submenuDrawer = this.shadowRoot.querySelector(".submenu-drawer");
    this.mobileMegaMenus.forEach((megamenu, key) => {
      const activeSubItem = megamenu.querySelector(".sub-item");
      megamenu.querySelector(".grid").classList.add("accordion", "gap-4", "py-24");
      megamenu.setAttribute("data-target", megamenu.getAttribute("id"));
      const activeCloseDrawerBtn = closeDrawer.cloneNode(true);
      const activebackBtn = backBtn.cloneNode(true);
      activebackBtn.setAttribute("id", `${backBtn.getAttribute("id")}-${key}`);
      activeCloseDrawerBtn.setAttribute("id", `${closeDrawer.getAttribute("id")}-${key}`);
      activebackBtn.classList.add("hidden", "absolute", "top-12", "py-18", "left-20", "pr-20");
      activeCloseDrawerBtn.classList.add("hidden", "absolute", "top-12", "py-16", "right-20", "pl-24");
      activeSubItem.parentNode.insertBefore(activebackBtn, activeSubItem);
      activeSubItem.parentNode.insertBefore(activeCloseDrawerBtn, activeSubItem.nextSibling);
      const menuWrappers = megamenu.querySelectorAll(".menu-item--wrapper");
      if (menuWrappers.length > 1) {
        menuWrappers.forEach((menuWrapper) => {
          const subItemWrapper = menuWrapper.querySelector(".menu__sub-item--wrapper");
          const megaMenuHeading = menuWrapper.querySelector("h3");
          if (megaMenuHeading && subItemWrapper) {
            const accordionToggle = document.createElement("button");
            accordionToggle.classList.add(
              "js-acc-btn",
              "accordion-toggle",
              "acc__btn",
              "flex",
              "items-center",
              "justify-between",
              "py-14",
              "w-full",
              "h-[3rem]",
              "border-charcoal-10"
            );
            const titleSpan = document.createElement("span");
            titleSpan.classList.add("acc__title", "redesign-body-5", "text-charcoal-100");
            titleSpan.innerHTML = megaMenuHeading.innerHTML;
            const iconWrapper = document.createElement("span");
            iconWrapper.classList.add("accordion-icons", "cursor-pointer");
            iconWrapper.innerHTML = _JK.icons.plus + _JK.icons.minus;
            accordionToggle.appendChild(titleSpan);
            accordionToggle.appendChild(iconWrapper);
            megaMenuHeading.replaceWith(accordionToggle);
            subItemWrapper.classList.add("js-acc-menu", "acc__menu", "overflow-hidden", "transition-[height]", "duration-300", "ease-[ease-in-out]");
          }
        });
      }
    });
    const backBtnDOM = this.backBtn.parentElement;
    this.subItems.forEach((subItem, key) => {
      subItem.addEventListener("click", (e) => {
        e.preventDefault();
        if (backBtnDOM == null ? void 0 : backBtnDOM.classList.contains("hidden")) {
          backBtnDOM == null ? void 0 : backBtnDOM.classList.remove("hidden");
        }
        const activeMegaMenu = this.mobileMenu.querySelector(`#${e.target.dataset.parent}`);
        activeMegaMenu == null ? void 0 : activeMegaMenu.setAttribute("aria-expanded", true);
        const copyMegaMenu = activeMegaMenu.cloneNode(true);
        const itemContent = copyMegaMenu.querySelector(".menu__item--content");
        itemContent.querySelector(".menu__item--content-container").classList.remove("pt-40");
        itemContent == null ? void 0 : itemContent.removeAttribute("style");
        submenuDrawer.innerHTML = "";
        const mobileDrawerHeight = submenuDrawer.clientHeight;
        submenuDrawer.appendChild(copyMegaMenu);
        submenuDrawer.querySelectorAll(".menu-item--wrapper").forEach((itemWrapper) => {
          itemWrapper.style.textAlign = "left";
        });
        submenuDrawer.querySelector(".menu__item--content").classList.remove("invisible", "opacity-0", "w-0", "border-t", "border-t-[1px]", "border-t-[var(--color-charcoal-10)]");
        const submenuDrawerAccordion = submenuDrawer.querySelector(".accordion");
        submenuDrawerAccordion.classList.remove("px-[1.5rem]");
        submenuDrawerAccordion.setAttribute("id", `${subItem.getAttribute("id")}-${key}`);
        if (submenuDrawerAccordion.style.maxHeight) {
          submenuDrawerAccordion.style.maxHeight = null;
        } else {
          const availableHeight = mobileDrawerHeight - 100;
          submenuDrawerAccordion.style.maxHeight = `${availableHeight}px`;
          submenuDrawerAccordion.style.overflowY = "auto";
        }
        submenuDrawer.querySelector(".sub-item.has--dropdown").classList.remove("text-ivory", "pb-[0.4375rem]");
        submenuDrawer.querySelector(".sub-item.has--dropdown").classList.add("text-charcoal-100");
        submenuDrawer.querySelectorAll(".nav__menu").forEach((navmenu) => {
          navmenu.classList.add("col-span-4");
        });
        submenuDrawer.querySelectorAll(".image-block").forEach((navmenu) => {
          navmenu.classList.add("col-span-2");
        });
        this.handleAccordionMenu("accordion-toggle", "accordion-content", "submenu-mobile__drawer");
        submenuDrawer.classList.remove("translate-x-full");
        submenuDrawer.classList.add("translate-x-0");
        const closeBtnMainDrawer = submenuDrawer.querySelector(".mobile__menu--close-drawer");
        const backBtnMainDrawer = submenuDrawer.querySelector(".mobile__menu--back-drawer");
        backBtnMainDrawer.classList.remove("hidden");
        closeBtnMainDrawer.classList.remove("hidden");
        backBtnMainDrawer.addEventListener("click", () => {
          if (!(backBtnDOM == null ? void 0 : backBtnDOM.classList.contains("hidden"))) {
            backBtnDOM == null ? void 0 : backBtnDOM.classList.add("hidden");
          }
          activeMegaMenu.setAttribute("aria-expanded", false);
          submenuDrawer.innerHTML = "";
          submenuDrawer.classList.remove("translate-x-0");
          submenuDrawer.classList.add("translate-x-full");
          this.menudrawer.classList.add("translate-x-0");
          this.menudrawer.classList.remove("-translate-x-full");
          document.body.classList.remove("fixed");
          document.body.classList.add("ui-active");
        });
        closeBtnMainDrawer.addEventListener("click", () => {
          activeMegaMenu.setAttribute("aria-expanded", false);
          submenuDrawer.innerHTML = "";
          submenuDrawer.classList.remove("translate-x-0");
          submenuDrawer.classList.add("translate-x-full");
          this.menudrawer.classList.remove("translate-x-0");
          this.menudrawer.classList.add("-translate-x-full");
          backBtnMainDrawer.classList.add("hidden");
          document.body.classList.remove("fixed", "ui-active", "overflow-hidden");
        });
      });
    });
  }
  handleAccordionMenu(accordionSelectors, accordionContents, accordionId) {
    if (!(SDG == null ? void 0 : SDG.accordion)) {
      console.error("SDG.accordionRedesign is not available.");
      return;
    }
    const accordionMegaMenu = SDG.accordionRedesign({
      dom: {
        btn: accordionSelectors,
        id: accordionId,
        menu: accordionContents
      },
      open_option: 0
    }, this.shadowRoot);
    accordionMegaMenu.init(this.shadowRoot);
  }
  /**
  * Handles the tab switching behavior for the mobile mega menu.
  *
  * This function supports matching the current tab based on the page path or Shopify context (`SDG.Data.context`),
  * adds/removes active tab styles, and displays corresponding tab content panels.
  * 
  * Key Features:
  * - Highlights the matching tab based on `window.location.pathname`.
  * - Matches and displays the appropriate tab content using `data-menu-context`.
  * - Registers `click`, `touchstart`, and `touchend` events for interaction support.
  * - Dynamically updates the `.account__links-mobile` position based on the height of the active tab content.
  *
  * @param {NodeList} tabSelector - A list of tab elements (e.g., `.menu-item`)
  * @param {NodeList} tabContentSelector - A list of corresponding tab content panels (e.g., `.menu-item--content`)
  */
  handleMobileTabMenu(tabSelector, tabContentSelector) {
    var _a, _b;
    const tabs = tabSelector;
    const tabContents = tabContentSelector;
    const context = ((_b = (_a = SDG == null ? void 0 : SDG.Data) == null ? void 0 : _a.context) == null ? void 0 : _b.toLowerCase()) || "";
    const currentPath = window.location.pathname;
    let matchedTab = null;
    tabs.forEach((tab) => {
      const tabLink = tab;
      if (tab.pathname && currentPath === tab.pathname) {
        tabs.forEach((tab2) => tab2.classList.remove("active-tab"));
        tabContents.forEach((content) => content.classList.remove("active-content", "hidden"));
        tabLink.classList.add("active-tab");
        tabLink.nextElementSibling.classList.add("active-content");
        matchedTab = true;
      }
    });
    tabs.forEach((tab, key) => {
      var _a2;
      const tabContent = tabContents[key];
      tab.setAttribute("data-tab", tab.getAttribute("id"));
      tabContent.setAttribute("id", tab.getAttribute("id"));
      tab.removeAttribute("id");
      const tabContext = (_a2 = tabContent.getAttribute("data-menu-context")) == null ? void 0 : _a2.toLowerCase();
      if (tabContext === context) {
        if (matchedTab != true) {
          tab.classList.add("active-tab");
        }
        tabContent.classList.add("active-content");
        tabContent.classList.remove("invisible");
        tabContent.classList.add("visible");
      }
      ["touchstart", "touchend", "click"].forEach((eventType) => {
        tab.addEventListener(eventType, (e) => {
          if (e.currentTarget.classList.contains("has--sub-item")) {
            if (e.cancelable) {
              e.preventDefault();
            }
            tabContents.forEach((content, k) => {
              tabs[k].classList.remove("active-tab");
              if (content.classList.contains("active-content")) {
                content.removeAttribute("style");
                content.classList.remove("active-content");
              }
              content.classList.add("hidden");
            });
            tab.classList.add("active-tab");
            const targetTab = tab.getAttribute("data-tab");
            const currentTab = this.shadowRoot.getElementById(targetTab);
            currentTab.classList.remove("hidden", "invisible");
            currentTab.classList.add("active-content");
            const mainMenuHeight = currentTab.offsetHeight + 160;
            currentTab.style.height = `${currentTab.offsetHeight - 60}px`;
            if (mainMenuHeight > window.innerHeight) {
              currentTab.classList.add("overflow-y-auto");
            } else {
              currentTab.classList.remove("overflow-y-auto");
            }
          }
        });
      });
    });
  }
  openMobileMenu() {
    this.mobileBTN.addEventListener("click", () => {
      var _a;
      (_a = this.menudrawer.querySelector(".mobile__menu--back-drawer")) == null ? void 0 : _a.classList.add("hidden");
      this.searchModal.close();
      this.menudrawer.classList.remove("-translate-x-full");
      this.menudrawer.classList.add("translate-x-0");
      document.body.classList.add("fixed", "overflow-hidden", "ui-active");
      this.mobileBTN.setAttribute("aria-expanded", "true");
      const activeTab = this.menudrawer.querySelector(".menu-item--content.active-content");
      const accountLinks = this.menudrawer.querySelector(".account__links-mobile");
      this.menudrawer.querySelectorAll(".menu-item--content").forEach((menuItem) => {
        const existingAccountMenu = menuItem.querySelector(".account__links-mobile");
        if (existingAccountMenu) {
          menuItem.removeChild(existingAccountMenu);
        }
        const accountMenu = accountLinks.cloneNode(true);
        accountMenu.classList.remove("hidden", "absolute");
        if (!menuItem.querySelector(".account__links-mobile")) {
          accountMenu.classList.add("pt-28");
          menuItem.appendChild(accountMenu);
        }
      });
      activeTab.removeAttribute("style");
      const activeTabHeight = (activeTab == null ? void 0 : activeTab.offsetHeight) || 0;
      const spacing = 100;
      const totalHeight = activeTabHeight + spacing;
      activeTab.style.height = `${activeTabHeight - 60}px`;
      if (accountLinks) {
        accountLinks.classList.add("hidden");
      }
      if (totalHeight > window.innerHeight) {
        activeTab.classList.add("overflow-y-auto");
      } else {
        activeTab.classList.remove("overflow-y-auto");
      }
      this.menudrawer.querySelectorAll(".menu__item--content").forEach((menuItem) => {
        menuItem.style.display = "none";
      });
    });
  }
  closeMobileMenu() {
    this.closeDrawer.addEventListener("click", () => {
      this.menudrawer.classList.remove("translate-x-0");
      this.menudrawer.classList.add("-translate-x-full");
      document.body.classList.remove("fixed", "overflow-hidden", "ui-active");
      this.mobileBTN.setAttribute("aria-expanded", "false");
      const drawer = this.shadowRoot.querySelector("#mobile__menu-drawer");
      const wrapper = this.shadowRoot.querySelector(".mobile__menu-drawer--wrapper");
      drawer == null ? void 0 : drawer.classList.remove("overflow-y-auto");
      if (wrapper) wrapper.style.height = "";
    });
  }
  // Attach event listeners for the country selector trigger.
  attachCountrySelectorTrigger() {
    if (!this.menudrawer) return;
    this.menudrawer.addEventListener("click", (event) => {
      var _a;
      const trigger = event.target.closest(".js-open-country-selector");
      if (!trigger) return;
      (_a = this.countrySelector) == null ? void 0 : _a.openDrawer(event);
    });
  }
}
customElements.define("custom-header", CustomHeader);
class JKCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    var _a, _b;
    const linkTailwind = document.createElement("link");
    linkTailwind.rel = "stylesheet";
    linkTailwind.href = (_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.assetTailwindStyle;
    const linkStyle = document.createElement("link");
    linkStyle.rel = "stylesheet";
    linkStyle.href = (_b = _JK == null ? void 0 : _JK.config) == null ? void 0 : _b.assetThemeStyle;
    const cartTemplate = document.querySelector(".custom__cart-drawer");
    if (!cartTemplate) {
      console.warn("[JKCartDrawer] Cart drawer section not found.");
      return;
    }
    const template = document.createElement("template");
    template.innerHTML = `
      <style>
        :host {
          --tw-translate-x: 0;
          --tw-translate-y: 0;
          --tw-translate-z: 0;
          --tw-scale-x: 1;
          --tw-scale-y: 1;
          --tw-scale-z: 1;
          --tw-rotate-x: initial;
          --tw-rotate-y: initial;
          --tw-rotate-z: initial;
          --tw-skew-x: initial;
          --tw-skew-y: initial;
          --tw-space-y-reverse: 0;
          --tw-border-style: solid;
          --tw-leading: initial;
          --tw-font-weight: initial;
          --tw-tracking: initial;
          --tw-shadow: 0 0 #0000;
          --tw-shadow-color: initial;
          --tw-shadow-alpha: 100%;
          --tw-inset-shadow: 0 0 #0000;
          --tw-inset-shadow-color: initial;
          --tw-inset-shadow-alpha: 100%;
          --tw-ring-color: initial;
          --tw-ring-shadow: 0 0 #0000;
          --tw-inset-ring-color: initial;
          --tw-inset-ring-shadow: 0 0 #0000;
          --tw-ring-inset: initial;
          --tw-ring-offset-width: 0px;
          --tw-ring-offset-color: #fff;
          --tw-ring-offset-shadow: 0 0 #0000;
          --tw-outline-style: solid;
          --tw-blur: initial;
          --tw-brightness: initial;
          --tw-contrast: initial;
          --tw-grayscale: initial;
          --tw-hue-rotate: initial;
          --tw-invert: initial;
          --tw-opacity: initial;
          --tw-saturate: initial;
          --tw-sepia: initial;
          --tw-drop-shadow: initial;
          --tw-drop-shadow-color: initial;
          --tw-drop-shadow-alpha: 100%;
          --tw-drop-shadow-size: initial;
          --tw-duration: initial;
          --tw-ease: initial;
          --tw-content: "";
        }
      </style>
      ${cartTemplate.innerHTML}
    `;
    this.shadowRoot.appendChild(linkTailwind);
    this.shadowRoot.appendChild(linkStyle);
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    cartTemplate.remove();
    const displayDelay = 1e3;
    setTimeout(() => {
      this.style.display = "block";
    }, displayDelay);
    this.cartComponent = new CartComponent(this.shadowRoot);
    this.cartComponent.refreshElementRefs();
    this.cartComponent.init();
  }
  openDrawer() {
    this.cartComponent.openDrawer();
  }
}
customElements.define("jk-cart-drawer", JKCartDrawer);
class JKFooter extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }
  connectedCallback() {
    const linkTailwind = document.createElement("link");
    linkTailwind.rel = "stylesheet";
    linkTailwind.href = _JK.config.assetTailwindStyle;
    const linkStyle = document.createElement("link");
    linkStyle.rel = "stylesheet";
    linkStyle.href = _JK.config.assetThemeStyle;
    const footerTemplate = document.querySelector("#shopify-section-redesign-footer");
    if (!footerTemplate) {
      console.warn("[JKFooter] Footer section not found.");
      return;
    }
    const template = document.createElement("template");
    template.innerHTML = `
      <style>
        :host {
          --tw-translate-x: 0;
          --tw-translate-y: 0;
          --tw-translate-z: 0;
          --tw-scale-x: 1;
          --tw-scale-y: 1;
          --tw-scale-z: 1;
          --tw-rotate-x: initial;
          --tw-rotate-y: initial;
          --tw-rotate-z: initial;
          --tw-skew-x: initial;
          --tw-skew-y: initial;
          --tw-space-y-reverse: 0;
          --tw-border-style: solid;
          --tw-leading: initial;
          --tw-font-weight: initial;
          --tw-tracking: initial;
          --tw-shadow: 0 0 #0000;
          --tw-shadow-color: initial;
          --tw-shadow-alpha: 100%;
          --tw-inset-shadow: 0 0 #0000;
          --tw-inset-shadow-color: initial;
          --tw-inset-shadow-alpha: 100%;
          --tw-ring-color: initial;
          --tw-ring-shadow: 0 0 #0000;
          --tw-inset-ring-color: initial;
          --tw-inset-ring-shadow: 0 0 #0000;
          --tw-ring-inset: initial;
          --tw-ring-offset-width: 0px;
          --tw-ring-offset-color: #fff;
          --tw-ring-offset-shadow: 0 0 #0000;
          --tw-outline-style: solid;
          --tw-blur: initial;
          --tw-brightness: initial;
          --tw-contrast: initial;
          --tw-grayscale: initial;
          --tw-hue-rotate: initial;
          --tw-invert: initial;
          --tw-opacity: initial;
          --tw-saturate: initial;
          --tw-sepia: initial;
          --tw-drop-shadow: initial;
          --tw-drop-shadow-color: initial;
          --tw-drop-shadow-alpha: 100%;
          --tw-drop-shadow-size: initial;
          --tw-duration: initial;
          --tw-ease: initial;
          --tw-content: "";
        }
      </style>
      ${footerTemplate.innerHTML}
    `;
    this.shadowRoot.appendChild(linkTailwind);
    this.shadowRoot.appendChild(linkStyle);
    this.shadowRoot.appendChild(template.content.cloneNode(true));
    footerTemplate == null ? void 0 : footerTemplate.remove();
    this.style.display = "block";
    new CustomFooter(this.shadowRoot);
  }
}
customElements.define("jk-footer", JKFooter);
document.addEventListener("DOMContentLoaded", () => {
  initOsanoDialogGuards();
});
